export const SIA_EMBED_URL_TEMPLATE =
  'https://gastronaut-sia.web.app/:restaurantId/default/calls/embed';

export const SIA_UPGRADE_PENDING_KEY = 'sia-upgrade-pending';
export const SIA_UPGRADE_PENDING_TTL_MS = 10 * 60 * 1000;

export const buildSiaEmbedUrl = (restaurantId: string) =>
  SIA_EMBED_URL_TEMPLATE.replace(':restaurantId', restaurantId);

export const buildSiaSettingsEmbedUrl = (restaurantId: string) =>
  buildSiaEmbedUrl(restaurantId).replace('/calls/', '/settings/');

export const buildSiaTodosEmbedUrl = (restaurantId: string) =>
  buildSiaEmbedUrl(restaurantId).replace('/calls/', '/todos/');

type SiaUpgradePending = {
  restaurantId: string;
  at: number;
};

const readPendingSiaUpgrade = (): SiaUpgradePending | null => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.sessionStorage.getItem(SIA_UPGRADE_PENDING_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as SiaUpgradePending;

    if (
      !parsed ||
      typeof parsed.restaurantId !== 'string' ||
      typeof parsed.at !== 'number'
    ) {
      window.sessionStorage.removeItem(SIA_UPGRADE_PENDING_KEY);
      return null;
    }

    if (Date.now() - parsed.at > SIA_UPGRADE_PENDING_TTL_MS) {
      window.sessionStorage.removeItem(SIA_UPGRADE_PENDING_KEY);
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const setPendingSiaUpgrade = (restaurantId: string) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(
      SIA_UPGRADE_PENDING_KEY,
      JSON.stringify({
        restaurantId,
        at: Date.now(),
      } as SiaUpgradePending),
    );
  } catch {
    // noop
  }
};

export const clearPendingSiaUpgrade = (restaurantId?: string | null) => {
  if (typeof window === 'undefined') return;
  try {
    const pending = readPendingSiaUpgrade();
    if (!pending) {
      window.sessionStorage.removeItem(SIA_UPGRADE_PENDING_KEY);
      return;
    }

    if (!restaurantId || pending.restaurantId === restaurantId) {
      window.sessionStorage.removeItem(SIA_UPGRADE_PENDING_KEY);
    }
  } catch {
    // noop
  }
};

export const hasPendingSiaUpgrade = (restaurantId: string | null) => {
  if (!restaurantId) return false;
  const pending = readPendingSiaUpgrade();
  return pending?.restaurantId === restaurantId;
};
